import { render, staticRenderFns } from "./ProductionTaskManagement.vue?vue&type=template&id=64ac128a&scoped=true"
import script from "./ProductionTaskManagement.vue?vue&type=script&lang=js"
export * from "./ProductionTaskManagement.vue?vue&type=script&lang=js"
import style0 from "./ProductionTaskManagement.vue?vue&type=style&index=0&id=64ac128a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ac128a",
  null
  
)

export default component.exports